import { styled } from '@mui/material';

import AcadlyPlusIcon from '../../../../icons/PlusIcon';

export const PlusIcon = styled(AcadlyPlusIcon)(({ theme }) => ({
  borderRadius: 4,
  backgroundColor: theme.palette.primary[500],
  color: theme.palette.common.white,
  margin: theme.spacing(0, 1, -1),
}));
